import { Resources } from './../../../../../models/resources';
import { Component, OnInit, ViewChild } from '@angular/core';
import { PlyrComponent } from 'ngx-plyr';
import * as jquery from 'jquery';
import { UserService } from 'src/app/services/user.service';
import { ActivatedRoute } from '@angular/router';
import { map, tap } from 'rxjs/operators';
import { Role } from 'src/app/models';
import { UserNavigationComponent } from 'src/app/partials/navigation/user-navigation/user-navigation.component';
import { AdminService } from 'src/app/services/admin.service';
import { AuthService } from 'src/app/services/auth.service';
import { PortfolioNavigationComponent } from 'src/app/partials/navigation/portfolio-navigation/portfolio-navigation.component';
import * as Plyr from 'plyr';

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss']
})
export class ViewComponent implements OnInit {

  @ViewChild(PlyrComponent, { static: true }) plyr: PlyrComponent;
  @ViewChild(UserNavigationComponent) userNavigation;
  @ViewChild(PortfolioNavigationComponent) portfolioNavigation;

  // Audio Player
  audioPlayer: Plyr;
  audioSourcePreview = '';
  audioUploadLabel = 'Upload';
  audioUploadFile: any;
  audioError = false;
  audioCurrentTimeText = '';
  audioDurationText = '';

  audioSources: Plyr.Source[] = [];
  audioOptions: Plyr.Options = {
    controls: ['progress']
  };

  modalText = 'Loading...';
  resourceId = 0;
  resource: Resources = new Resources();
  nonAdminRoles = [Role.Individual, Role.Manager, Role.Employee];

  playButtonActive = true;
  pauseButtonActive = false;
  showDuration = false;

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private adminService: AdminService,
    public authService: AuthService,
  ) { }

  ngOnInit(): void {

    // document.body.classList.add("test");
    // var el: any = document.getElementsByClassName("test")[0];
    // el.style.backgroundImage = "url('https://takeabreath-dev.s3.ap-southeast-2.amazonaws.com/resources/covers/161180914994472800.jpeg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAWTPOXR6ZEDUKMTCP%2F20210316%2Fap-southeast-2%2Fs3%2Faws4_request&X-Amz-Date=20210316T104323Z&X-Amz-SignedHeaders=host&X-Amz-Expires=7200&X-Amz-Signature=d4d8d0b8e808b897535ab8a59e7069ab5f8450b2c14b2bcb5f75489d3baf308e')";

    this.getRouteParams();

    const currentRole = this.authService.currentUserValue.role;
    if (currentRole && this.nonAdminRoles.indexOf(currentRole) >= 0) {
      this.getUser();
    } else {
      this.authService.getTokenDetails(this.authService.tokenValue)
        .subscribe(response => {
          if (response && response.data.role === Role.Admin) {
            this.getAdmin();
          } else {
            this.getUser();
          }
        });
    }
  }

  private getRouteParams() {
    this.resourceId = this.route.snapshot.params.id;
  }

  private getUser() {
    this.userService.getProfile()
      .pipe(

        // Get User Details
        map(user => user.data.user),
        tap(user => {
          this.portfolioNavigation.user = user;
        }),

      )
      .subscribe(
        response => {
          if (response) {
            this.getResource();
          }
        },
        error => { }
      );
  }

  private getAdmin() {
    this.adminService.getProfile()
      .pipe(

        // Get User Details
        map(user => user.data.user),
        tap(user => {
          this.portfolioNavigation.user = user;
        }),

      )
      .subscribe(
        response => {
          if (response) {
            this.getResource();
          }
        },
        error => { }
      );
  }

  private getResource(): void {
    this.showProgressModal();
    this.userService.getResource(this.resourceId)
      .subscribe(response => {

        this.hideProgressModal();

        if (response.data.hasOwnProperty('resource')) {
          this.resource = response.data.resource;

          this.audioSources = [
            {
              src: this.resource.link_url,
              type: 'audio/mpeg'
            }
          ];

        }

      });
  }

  private formatTime(time: number): any {   
    // Hours, minutes and seconds
    var hrs = ~~(time / 3600);
    var mins = ~~((time % 3600) / 60);
    var secs = ~~time % 60;

    // Output like "1:01" or "4:03:59" or "123:03:59"
    var ret = "";
    if (hrs > 0) {
        ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
    }
    ret += "" + mins + ":" + (secs < 10 ? "0" : "");
    ret += "" + secs;
    return ret;
}

  play(): void {
    this.audioPlayer.play();
    this.playButtonActive = false;
    this.pauseButtonActive = true;

    this.audioDurationText = '-' + this.formatTime(this.audioPlayer.duration);

    this.showDuration = true;
  }

  pause(): void {
    this.audioPlayer.pause();
    this.playButtonActive = true;
    this.pauseButtonActive = false;

    this.audioCurrentTimeText = this.formatTime(this.audioPlayer.currentTime);
  }

  timeupdate(event: Plyr.PlyrEvent) {
    this.audioCurrentTimeText = this.formatTime(this.audioPlayer.currentTime);
  }

  private showProgressModal() {
    jquery('#loaderSpin').show();
  }

  private hideProgressModal() {
    jquery('#loaderSpin').hide();
  }

}
